export const getStandalonePromptRecommendations = state => {
  var _state$standaloneProm;
  return ((_state$standaloneProm = state.standalonePromptRecommendations) === null || _state$standaloneProm === void 0 ? void 0 : _state$standaloneProm.questions) || [];
};